// @flow
import * as React from 'react';

import { Api, createApiData } from 'app/common/context/Api';
import shopApi from 'app/actions/shopApi';
import * as shippingTypes from 'app/common/actions/shop/order/shippingMethodTypes';
import i18n from 'app/i18n';


export const ShippingMethods = createApiData();

const requestsData = {
  shippingMethods: {
    path: 'shipping_methods',
    type: 'get',
    cbErrorTextCreate: (/* error */) => (i18n.t('shop:error_api_shipping_methods')),
    autoRequest: true,
  },
};

export type ShippingMethod = {
  id: number,
  name: string,
  shipping_method_type: $Values<typeof shippingTypes>,
  shipping_cost: string,
}

type State = {
  content: {
    data: Array<ShippingMethod>,
  },
  loading: boolean,
  request: {
    shippingMethods: (void) => Promise<void>,
  },
  error?: { [string]: mixed },
}

const initialContent = {
  data: [],
};

export type Props = {
  children: React.Node | (value: State) => React.Node,
}

const ShippingMethodsApi = ({ children }: Props) => (
  <Api
    fnApi={shopApi}
    apiData={ShippingMethods}
    descriptions={requestsData}
    initialContent={initialContent}
  >
    {children}
  </Api>
);

export default ShippingMethodsApi;
